export default "__VITE_ASSET__BsomaQPG__"